module.exports = __webpack_public_path__ + "static/media/TRIAL-2-if-wrong.61f11b87.mp3";